export default "__VITE_ASSET__f8765c93__"